import {
    RESET_EXPORT_REPORT,
    CREATE_EXPORT_REPORT,
    CREATE_EXPORT_REPORT_SUCCESS,
    CREATE_EXPORT_REPORT_FAIL,
    CHECK_EXPORT_REPORT_STATUS,
    CHECK_EXPORT_REPORT_STATUS_FAIL,
    CHECK_EXPORT_REPORT_STATUS_SUCCESS
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    init: {},
    status: {}
};

export const resetExportReport = () => {
    return {
        init: {},
        status: {}
    };
};

export const createExportReportSuccess = (state, action) => {
    let newState = state;
    newState.init = action.exportReport;
    return newState;
};

export const updateExportReportStatusSuccess = (state, action) => {
    let newState = state;
    newState.status = action.reportStatus;
    return newState;
};

export const createExportReportFail = (state, action) => {
    let newState = state;
    newState.status = 'ERROR_RETRY';
    return newState;
};

const handlers = {
    [RESET_EXPORT_REPORT]: resetExportReport,
    [CREATE_EXPORT_REPORT_SUCCESS]: createExportReportSuccess,
    [CHECK_EXPORT_REPORT_STATUS_SUCCESS]: updateExportReportStatusSuccess,
    [CREATE_EXPORT_REPORT_FAIL]: createExportReportFail
};

export default (state = INITIAL_STATE, action = {}) => {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
};
